import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createPromise } from 'redux-promise-middleware';
import { routerMiddleware } from 'connected-react-router';
import { middleware as analyticsMiddleware } from '@carvana/analytics';
import AnalyticsConfig from './analytics-config';
import createRootReducer from './reducers';
import dataDogLogger from './middleware/dataDogLogger';
import history from './history';
import registry from './registry';
import previousRouteMiddleware from './middleware/router/middleware';

const logger = createLogger({ level: 'info', collapsed: true });
const middleware = [
  routerMiddleware(history),
  previousRouteMiddleware,
  thunk,
  createPromise({ promiseTypeSuffixes: ['LOADING', 'SUCCESS', 'ERROR'] }),
  dataDogLogger,
  analyticsMiddleware(AnalyticsConfig),
  process.env.NODE_ENV !== 'production' && logger
].filter(Boolean);
const composeEnhancers = composeWithDevTools({
  actionsBlacklist:
    process.env.NODE_ENV === 'production'
      ? ['@@EXPERIMENT_', '@@analytics/', '@@purchase_analytics/']
      : [],
  trace: process.env.LOCAL === 'true'
});

const composedEnhancers = composeEnhancers(applyMiddleware(...middleware));
const store = createStore(
  createRootReducer(),
  Object.assign({}, registry.getDefaultStates()),
  composedEnhancers
);

registry.setChangeListener(reducers => {
  store.replaceReducer(createRootReducer(reducers));
});

registry.init(store);

export default store;
export { registry };
